import React from "react";
import { Helmet } from "react-helmet-async";

interface ArticleSchemaProps {
  headline: string;
  description?: string | null;
  authorName?: string | null;
  datePublished?: string | null;
  dateModified?: string | null;
  image?: string | null;
  url?: string | null;
  publisherName?: string | null;
  publisherLogo?: string | null;
}

const ArticleSchema: React.FC<ArticleSchemaProps> = ({
  headline,
  description,
  authorName,
  datePublished,
  dateModified,
  image,
  url,
  publisherName,
  publisherLogo,
}) => {
  const schema: Record<string, any> = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline,
    ...(description && { description }),
    ...(authorName && {
      author: { "@type": "Person", name: authorName },
    }),
    ...(datePublished && { datePublished }),
    ...(dateModified && { dateModified }),
    ...(image && { image }),
    ...(url && { mainEntityOfPage: url }),
    ...(publisherName && {
      publisher: {
        "@type": "Organization",
        name: publisherName,
        ...(publisherLogo && {
          logo: { "@type": "ImageObject", url: publisherLogo },
        }),
      },
    }),
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default ArticleSchema;
